import Nullstack from 'nullstack';
export default function IconCurrencyYenOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-yen-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v-7m5 -7l-3.328 4.66"
  }), "   ", Nullstack.element("path", {
    d: "M8 17h8"
  }), "   ", Nullstack.element("path", {
    d: "M8 13h5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}